import React from 'react';
import PropTypes from 'prop-types';
import DevHelper from '../DevHelper';
import DiscoveryProvider from '../../contexts/discoveryContext/provider';
import DiscoveryProviderV2 from '../../contexts/discoveryContext/providerV2';

if (__CLIENT__ && !__DEVELOPMENT__) {
  // Initialise Sentry error tracking for client-side bundle
  require('../../vendor/Raven'); // eslint-disable-line
}

/**
 * App component, container for all routes and components.
 * Sets up error tracking and global async requirements.
 */
const App = ({ children }) => (
  <DiscoveryProvider>
    <DiscoveryProviderV2>
      {children}
      <DevHelper />
    </DiscoveryProviderV2>
  </DiscoveryProvider>
);

App.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default App;
